/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Signin_TitleInputs */

const en_directory_ai_tools_studio_signin_title = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to upload your photos`)
};

const zh_directory_ai_tools_studio_signin_title = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后即可上传照片`)
};

/**
* | output |
* | --- |
* | "Sign in to upload your photos" |
*
* @param {Directory_Ai_Tools_Studio_Signin_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_signin_title = /** @type {((inputs?: Directory_Ai_Tools_Studio_Signin_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Signin_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_signin_title(inputs)
	return zh_directory_ai_tools_studio_signin_title(inputs)
});
export { directory_ai_tools_studio_signin_title as "directory.ai_tools.studio.signin_title" }